import { cva } from '@/styled-system/css';

export const paginationPageButtonRecipe = cva({
  base: {
    position: 'relative',
    display: 'inline-flex',
    flexGrow: 0,
    alignItems: 'center',
    justifyContent: 'center',
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow, background-color, color',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.200}',
    },
    transitionTimingFunction: '{easings.ease}',
    width: 'action.md',
    height: 'action.md',
    backgroundColor: { base: 'bg.invisible' },
    borderRadius: 'shape.ellipse',
    boxShadowColor: { base: 'transparent.invisible' },
    boxShadow: {
      base: 'inset 0 0 0 {borderWidths.thick} var(--shadow-color)',
      _focusVisible: 'inset 0 0 0 {borderWidths.thick} var(--shadow-color), {shadows.focus}',
    },
    color: {
      base: 'text.neutral',
    },
    textStyle: 'body-bold',
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
      },
      false: {},
    },
    selected: {
      true: {
        opacity: 1,
        color: { base: 'text.neutral' },
        backgroundColor: { base: 'bg.action.soft.selected.default' },
        boxShadowColor: { base: 'border.action.hero.selected.default' },
      },
      false: {
        cursor: 'pointer',
        color: {
          _hover: 'text.neutral-fixed',
          _active: 'text.neutral-fixed',
        },
        backgroundColor: {
          _hover: 'bg.action.bare.neutral.hover',
          _active: 'bg.action.bare.neutral.pressed',
        },
        boxShadowColor: {
          _active: 'transparent.invisible',
        },
      },
    },
  },
});
